// src/redux/actions/kitchenDiningActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types (inside the file)
const CREATE_KITCHEN_DINING_REQUEST = "CREATE_KITCHEN_DINING_REQUEST";
const CREATE_KITCHEN_DINING_SUCCESS = "CREATE_KITCHEN_DINING_SUCCESS";
const CREATE_KITCHEN_DINING_FAILURE = "CREATE_KITCHEN_DINING_FAILURE";

// Async Action
export const createKitchenDining = (formData) => async (dispatch) => {
  dispatch({ type: CREATE_KITCHEN_DINING_REQUEST });

  try {
    const res = await axios.post(
      `${BASE_URL}/api/maa_canteen/kitchen_dining/add`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: CREATE_KITCHEN_DINING_SUCCESS,
      payload: res.data.data,
    });

    toast.success("Kitchen dining added successfully");
    return res.data;
  } catch (error) {
    dispatch({
      type: CREATE_KITCHEN_DINING_FAILURE,
      payload:
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message,
    });

    toast.error("Failed to add kitchen dining");
    throw error;
  }
};
